// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"ae658120","655":"14a53bf8"}[chunkId] + ".chunk.js";
};